import { toQuery } from 'src/utils/utils';

import { handleResponse } from '../utils/auth-header';
import axios, { axiosOption } from '../utils/axios';

export const QuanlynapcuocService = {

  thongKe: (payload) => {
    let url = `/api/v1/quanlynapcuoc/thongKe?`;

    if (payload.username) {
      url += `&username=${payload.username}`
    };

    if (payload.ma_don) {
      url += `&ma_don=${payload.ma_don}`
    };

    if (payload.phone) {
      url += `&phone=${payload.phone}`
    };

    if (payload.kenh_yeu_cau) {
      url += `&kenh_yeu_cau=${payload.kenh_yeu_cau}`
    };

    if (payload.nha_mang) {
      url += `&nha_mang=${payload.nha_mang}`
    };

    if (payload.trang_thai) {
      url += `&trang_thai=${payload.trang_thai}`
    };

    if (payload.startDate && payload.endDate) {
      url += `&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  donChoHeThong: (payload) => {
    let url = `/api/v1/quanlynapcuoc/donChoHeThong?page=${payload.donchohethongpage}&count=${payload.donchohethonglimit}`;

    if (payload.username) {
      url += `&username=${payload.username}`
    };

    if (payload.ma_don) {
      url += `&ma_don=${payload.ma_don}`
    };

    if (payload.phone) {
      url += `&phone=${payload.phone}`
    };

    if (payload.kenh_yeu_cau) {
      url += `&kenh_yeu_cau=${payload.kenh_yeu_cau}`
    };

    if (payload.nha_mang) {
      //url += `&nha_mang=${payload.nha_mang}`
      url += `&nha_mang=${payload.operator.toUpperCase()}`
    };

    if (payload.boi_so) {
      url += `&boi_so=${payload.boi_so}`
    };

    if (payload.operator) {
      url += `&operator=${payload.operator}`
    };

    if (payload.trang_thai) {
      url += `&trang_thai=${payload.trang_thai}`
    };

    if (payload.dua) {
      url += `&dua=${payload.dua}`
    };

    if (payload.startDate && payload.endDate) {
      url += `&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  handleSuaPortNhieuMuc: (payload) => {
    return axios.post(`/api/v1/quanlynapcuoc/handleSuaPortNhieuMuc`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  chayTiep: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/chayTiep/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  chayTiepChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/chayTiepChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  daNap: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/daNap/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  daNapChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/daNapChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  huyDon: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/huyDon/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  huyDonChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/huyDonChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  tamDung: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/tamDung/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  tamDungChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/tamDungChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  choNap: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/choNap/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  choNapChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/choNapChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  dangNap: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/dangNap/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  dangNapChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/dangNapChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  thatBai: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/thatBai/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  thatBaiChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/thatBaiChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  hoanThanh: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/hoanThanh/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  batDauDon: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/batDauDon/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  batDauDonChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/batDauDonChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  duaDon: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/duaDon/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  duaDonChiTiet: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/duaDonChiTiet/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  updateBoiSo: (id, payload) => {
    return axios.post(`/api/v1/quanlynapcuoc/updateBoiSo/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  updateBoiSoChiTiet: (id, payload) => {
    return axios.post(`/api/v1/quanlynapcuoc/updateBoiSoChiTiet/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  guiOtp: (id) => {
    return axios.post(`/api/v1/quanlynapcuoc/guiOtp`, {id}, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  nhapOtp: (id, otp) => {
    return axios.post(`/api/v1/quanlynapcuoc/nhapOtp`, {id, otp}, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  approve: (id, payload) => {
    return axios.put(`/api/v1/quanlynapcuoc/approve/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  setTrangThai: (id, payload) => {
    return axios.put(`/api/v1/quanlynapcuoc/setTrangThai/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  create: (payload) => {
    return axios.post('/api/v1/quanlynapcuoc', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  save: (payload) => {
    return axios.post('/api/v1/quanlynapcuoc/import', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  update: (id, payload) => {
    return axios.put(`/api/v1/quanlynapcuoc/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  findAll: (page, count, payload) => {
    let url = `/api/v1/quanlynapcuoc?page=${page}&count=${count}`;

    if (payload.username) {
      url += `&username=${payload.username}`
    };

    if (payload.ma_don) {
      url += `&ma_don=${payload.ma_don}`
    };

    if (payload.phone) {
      url += `&phone=${payload.phone}`
    };

    if (payload.kenh_yeu_cau) {
      url += `&kenh_yeu_cau=${payload.kenh_yeu_cau}`
    };

    if (payload.nha_mang) {
      url += `&nha_mang=${payload.nha_mang}`
    };

    if (payload.trang_thai) {
      url += `&trang_thai=${payload.trang_thai}`
    };

    if (payload.startDate && payload.endDate) {
      url += `&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findAllByOrder: (id, page, count, payload) => {
    let url = `/api/v1/quanlynapcuoc/findAllByOrder/${id}?page=${page}&count=${count}`;

    if (payload.username) {
      url += `&username=${payload.username}`
    };

    if (payload.ma_don) {
      url += `&ma_don=${payload.ma_don}`
    };

    if (payload.phone) {
      url += `&phone=${payload.phone}`
    };

    if (payload.kenh_yeu_cau) {
      url += `&kenh_yeu_cau=${payload.kenh_yeu_cau}`
    };

    if (payload.trang_thai) {
      url += `&trang_thai=${payload.trang_thai}`
    };

    if (payload.startDate && payload.endDate) {
      url += `&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  listExport: (payload) => {
    let url = `/api/v1/quanlynapcuoc/listExport?page=${payload.page}&count=${payload.limit}`;

    if (payload.ma_don) {
      url += `&ma_don=${payload.ma_don}`
    };
    
    if (payload.message) {
      url += `&phone=${payload.phone}`
    };

    if (payload.startDate && payload.endDate) {
      url += `&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findAssign: (page, count) => {
    return axios.get(`/api/v1/quanlynapcuoc/assign?page=${page}&count=${count}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  find: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findOneChiTietDon: (id) => {
    return axios.get(`/api/v1/quanlynapcuoc/findOneChiTietDon/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findPosition: (position) => {
    return axios.get(`/api/v1/quanlynapcuoc/findPosition/${position}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  countAssign: () => {
    return axios.get(`/api/v1/quanlynapcuoc/count-assign`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  delete: (id) => {
    return axios.delete(`/api/v1/quanlynapcuoc/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  assign: (payload) => {
    return axios.post(`/api/v1/quanlynapcuoc/assign`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  history: (payload) => {
    return axios.get(`/api/v1/care/history?${toQuery(payload)}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  }
}